/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-extraneous-dependencies
*/
import './index.scss';

import React from 'react';
import createReactClass from 'create-react-class';
import Header from '../header';

const LightHeader = createReactClass({
  render() {
    return <Header {...this.props} className={`nav light ${this.props.className || ''}`}>
      { this.props.children }
    </Header>;
  },
});

export default LightHeader;
